// Mail raporu zamanlama ekle / düzenle penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'documents.mailSchedule';

export const mailScheduleGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Mail zamanlaması nasıl kurulur?'),
  intro: t(`${G}.intro`, 'Bu pencerede hangi raporun, hangi şubeler için, ne zaman ve kimlere otomatik mail olarak gideceğini belirlersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Zamanlama formu'),
    footer: t(`${G}.regions.footer`, 'Oluştur / Güncelle'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Ad, durum ve rapor tipi'),
      text: t(`${G}.s1.text`, 'Zamanlamaya isterseniz bir ad verin (ör. "Günlük Akşam Raporu"). Aktif / Pasif anahtarı gönderimi açar veya durdurur. "Rapor İçerik Tipi" mailde hangi raporun gideceğini seçer; şu an Gün Sonu Raporu kullanılabilir, "Yakında" etiketliler henüz seçilemez.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Zamanlamayı seçin'),
      text: t(`${G}.s2.text`, '"Hazır Zamanlama" listesinden bir seçenek seçmek en kolayıdır; rapor tipi (Günlük / Haftalık / Aylık) kendiliğinden ayarlanır. "Özel Cron" ile rapor tipini ve saati elle yazabilirsiniz.'),
      tips: [
        t(`${G}.s2.tip1`, 'Özel Cron 5 alan ister: dakika saat gün ay haftagünü. Örnek: "0 22 * * *" her gün 22:00.'),
        t(`${G}.s2.tip2`, 'Gönderim sıklığı rapor tipiyle uyuşmazsa sarı uyarı çıkar: mail her tetiklendiğinde rapor tipinin dönemi kadar (1 gün, 7 gün veya 1 ay) özet gider.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Şubeleri seçin'),
      text: t(`${G}.s3.text`, 'Şube seçmezseniz tüm şubeler tek raporda birleşik gönderilir. Birden çok şube seçerseniz her şube için ayrı mail gider.'),
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Alıcılar, CC ve saat dilimi'),
      text: t(`${G}.s4.text`, 'Alıcılar (To) alanına e-posta adresini yazıp ENTER\'a basın; en az 1 alıcı zorunludur. CC isteğe bağlıdır. Hatalı adresler kırmızı görünür ve kayda izin verilmez. Saat dilimi, zamanlamadaki saatin hangi bölgeye göre işleyeceğini belirler (varsayılan Türkiye UTC+3).'),
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Özeti kontrol edip kaydedin'),
      text: t(`${G}.s5.text`, 'Alttaki Özet kutusu raporu, zamanı, şube ve alıcı sayısını tek satırda gösterir. Doğruysa "Oluştur" (düzenlemede "Güncelle") ile kaydedin; zamanlama listeye eklenir ve aktifse belirtilen zamanda gönderilmeye başlar.'),
    },
  ],
});
